<template>
  <div
    id="promo-banner"
    class="promo"
  >
    <a href="https://www.positivegrid.com.cn/bias-fx2?utm_source=campaign page&utm_medium=FX 2 expansion packs campaign banner&utm_campaign=FX 2 expansion packs campaign">
      <div class="inner">
        <!-- 全站五折，买BIAS FX 2送金属扩展包
      <button @click="$router.push('/bias-fx2')">
        享钜惠
      </button> -->
        <!-- 微信搜索 PositiveGrid 并关注，获得第一手消息 -->
        <!-- <button>抢特惠</button> -->
        广州盈声科技有限公司，创新精神做音乐
      <!-- <button>购买</button> -->
      </div>
    </a>
  </div>
</template>

<script>
export default {
  components: {
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style scoped>
.promo {
  width: 100%;
  height: 42px;
  background: rgba(0, 0, 0, 0) linear-gradient(to right, rgb(77, 77, 77), rgb(173, 148, 111)) repeat scroll 0% 0%;
  position: fixed;
  z-index: 99;
  top: 0;
  color: white;
}
.inner {
  line-height: 42px;
  display: flex;
  justify-content: center;
  align-items: center;
}
button {
  margin-left: 1rem;
  width: auto;
  min-width: 60px;
}
a, a:visited {
  color: white;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/promo-bar.vue